export enum PetrolColors {
  Petrol180 = '#000C10',
  Petrol160 = '#001920',
  Petrol140 = '#002531',
  Petrol120 = '#003241',
  Petrol110 = '#003849',
  Petrol100 = '#003E51',
  Petrol80 = '#336574',
  Petrol60 = '#668B97',
  Petrol50 = '#809EA8',
  Petrol40 = '#99B2B9',
  Petrol30 = '#B2C5CB',
  Petrol20 = '#CCD8DC',
  Petrol15 = '#D9E2E5',
  Petrol10 = '#E5ECEE',
  Petrol5 = '#F2F5F6',
}

export enum GreenColors {
  Green180 = '#001C1E',
  Green160 = '#00373C',
  Green140 = '#00535A',
  Green120 = '#006E78',
  Green110 = '#007C87',
  Green100 = '#008A96',
  Green80 = '#33A1AB',
  Green60 = '#66B9C0',
  Green50 = '#80C4CB',
  Green40 = '#99D0D5',
  Green30 = '#B2DCDF',
  Green20 = '#CCE8EA',
  Green15 = '#D9EDEF',
  Green10 = '#E5F3F5',
  Green5 = '#F2F9FA',
}

export enum NeutralColors {
  Black = '#1B1B1B',
  Gray = '#666666',
  DarkGrey = '#75787B',
  OffWhite = '#A3A3A3',
  MediumGray = '#D1D1D1',
  LightGray = '#F4F4F3',
  White = '#FFFFFF',
}
